import { useCallback, useState } from 'react'

import { useShareAssetModalStore } from '@/lib/stores/shareAssetModalStore'

import { SelectableShareClass } from '@/lib/features/SmartShares/interfaces'

/**
 * Holds the share class the user has picked in the first step. Nothing is written to the share
 * asset modal store until they confirm with Next, so the rest of the flow only ever sees a
 * deliberate choice.
 */
export const useSelectShareClassModal = () => {
  const setShareClass = useShareAssetModalStore((state) => state.setShareClass)
  const [selectedShareClass, setSelectedShareClass] = useState<SelectableShareClass | null>(null)

  const selectShareClass = useCallback((shareClass: SelectableShareClass) => {
    setSelectedShareClass(shareClass)
  }, [])

  const confirmSelection = useCallback(() => {
    if (!selectedShareClass) {
      return
    }

    setShareClass(selectedShareClass)
  }, [selectedShareClass, setShareClass])

  return {
    selectedShareClass,
    selectShareClass,
    confirmSelection,
    isNextDisabled: !selectedShareClass,
  }
}
